<template>
	<ul :class='"list list-" + $parent.model'>

		<router-link tag='li' :to='($parent.subroute ? "/" + $parent.event + "-list" : "") + "/" + $parent.event + "-show/" + item.id + (is_archived(item) ? "/1" : "")' v-for="item in $parent.items.data" :key='item.id' :class='"list-" + $parent.model + "_item"'>
			<!-- ID: {{item.id}}<br /> -->
			<!-- @updatehere -->
			<!-- <h2 class="h6">{{item.id}}</h2> -->
			<span class="status status-primary"></span>


			<div class='list-flags' :class="getPriorityClass(item)">
                <span v-if='is_archived(item)' :title="$t('translations.archived')" v-html="$t('translations.archived')" class="icon icon-archived"></span>
				<span v-else-if='is_closed(item)' :title="$t('translations.closed')" v-html="$t('translations.closed')" class="icon icon-closed"></span>
                <template v-else>
					<span v-if='is_unassigned(item)' :title="$t('translations.new')" class="icon icon-unassigned"></span>
					<span v-if='is_assignedToMe(item)' :title='assignee_name(item)' v-html="$t('translations.mine')" class="icon icon-mine"> </span>
                    <span v-else-if='is_assignedToMyGroups(item)' :title='assignee_name(item)' v-html="$t('translations.mine')" class="icon icon-my-group"> </span>
					<span v-else-if='is_assigned(item)' :title='assignee_name(item)' v-html="$t('translations.assigned')" class="icon icon-assigned"> </span>
				</template>
				<!-- <span v-if='new_message(item)' title='Unread messages' class="icon icon-unread"></span> -->
				<template v-if='is_patient() && !is_archived(item)'>
                    <span v-if='new_message(item)' :title="$t('translations.unread_messages')" class="icon icon-unread"></span>
                </template>
				<template v-if='is_staff()'>
					<template v-if='has_unread_response(item)'>
						<span v-if='new_message(item)' :title="autobrand('translations.new_message_patient_unread')" class="icon icon-patient-unread-new">UN</span>
						<span v-else :title="autobrand('translations.patient_unread')" class="icon icon-patient-unread">U</span>
					</template>
					<template v-else-if='patient_read_all(item)'>
						<span v-if='new_message(item)' :title="autobrand('translations.new_message_patient_read_all')" class="icon icon-patient-read-new">RAN</span>
						<span v-else :title="autobrand('translations.patient_read_all')" class="icon icon-patient-read">RA</span>
					</template>
					<span v-else-if='new_message(item)' title='Unread messages' class="icon icon-unread"></span>

					<!-- <span v-if='staff_has_responded(item)' title='Patient has received a response' class="icon icon-staff-responded">R</span> -->
					<!-- <span v-else title='Patient has not received a response' class="icon icon-staff-not-responded">NR</span>-->
				</template>
			</div>

			<div class="d-flex flex-wrap thread-meta">
				<template v-if='item.user'>
					<h2 class="h6 mr-auto"><strong>{{formatSurname(item.user)}} <template v-if='item.user.gender || item.user.dob'>(<template v-if='item.user.gender'>{{item.user.gender.toUpperCase()}}</template><template v-if='item.user.gender && item.user.dob'>&nbsp;</template><template v-if='item.user.dob'>{{item.user.dob | getAge}}</template>)</template></strong></h2>
				</template>
				<!-- <template v-else-if='reportError("Missing user in thread", item)'>
				</template> -->
				<!-- <template v-if='reportError("Testing", item)'>
				</template> -->

				<span class="time-stamp">{{item.created_at| formatDateTime}}</span>
			</div>
			<p v-if='item.created_by && item.created_by != item.user_id'>
				{{ $t('translations.created_by')}}: {{formatSurname(item.created_by_user)}}
			</p>
			<p>{{(item.question_group && item.question_group.question_group_type_id == 1) ? $t('translations.qa_in_progress') : ""}} {{item.subject ? item.subject.substring(0,100) : "[" + $t('translations.no_subject') + "]"}}</p>

		</router-link>
	</ul>
</template>

<script>
	export default {
		props: [
		],
		data: function() {
			return {
                
            };
		},
		methods : {
			is_assigned(item) {
				if(item.thread_provider && (item.thread_provider.assigned_user_id || item.thread_provider.assigned_group_id)) {
					return true
				}
				return false;
			},
			is_unassigned(item) {
				if(item.thread_provider && (!item.thread_provider.assigned_user_id && !item.thread_provider.assigned_group_id)) {
					return true
				}
				return false;
			},
			is_assignedToMe(item) {
				if(item.thread_provider && item.thread_provider.assigned_user_id == this.$root.user.id) {
					return true
				}

				return false;
            },
            is_assignedToMyGroups(item) {
				if(item.thread_provider && item.thread_provider.assigned_group_id) {
					//alert("item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id);
					var val = this.$root.user.user_group.filter(obj => {
						//alert("obj.user_group_id: " + obj.user_group_id);
						//console.log("Comparing: " + "item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id + " to " + "obj.user_group_id: " + obj.user_group_id);
						return item.thread_provider.assigned_group_id == obj.user_group_id;
					});
					return val.length;
				}
				return false;
			},
			new_message(item) {
				if(this.is_patient() || this.is_assignedToMe(item) || this.is_assignedToMyGroups(item) || this.is_unassigned(item)) {
					if(!item.user_thread_read_status) {
						return true;
					}
					if(item.latest_message != null && typeof item.latest_message == "object" && item.latest_message.created_at > item.user_thread_read_status.read_at) {
						return true;
					}
				}
				return false;
			},

			is_closed(item) {
				if(item.closed_at) {
					return true
				}
				return false;
            },
            is_archived(item) {
				if(item.archived) {
					return true
				}
				return false;
			},
			staff_has_responded(item) {
				if(item.latest_message_to_patient) {
					return true;
				}
				return false;
			},
			has_unread_response(item) {
				if(item.latest_unread_message_to_patient) {
					return true;
				}
				return false;
			},
			patient_read_all(item) {
				if(this.staff_has_responded(item) && !this.has_unread_response(item)) {
					return true;
				}
				return false;
			},
			assignee_name(item) {
				if(item.thread_provider && item.thread_provider.assigned_user) {
					return item.thread_provider.assigned_user.surname + ", " + item.thread_provider.assigned_user.forenames;
				}
				else if(item.thread_provider && item.thread_provider.assigned_group) {
					return item.thread_provider.assigned_group.name;
				}
				return this.$t('translations.unassigned');

			},
			updateMessage: function () {
				this.message = this.$t('translations.updated')
				console.log(this.$el.textContent) // => 'not updated'
				this.$nextTick(function () {
					console.log(this.$el.textContent) // => 'updated'
				})
			},
			getPriorityClass(item) {
				if(this.is_staff()) {
					switch(item.thread_priovider.priority) {
						case -10: return "lower"; break;
						case 0: return "routine"; break;
						case 5: return "visit"; break;
						case 10: return "urgent"; break;
						case 20: return "emergency"; break;
					}
				}
            }

		}
    }
</script>
